const FACEBOOK = require("../assets/icons/facebook.png");
const INSTAGRAM = require("../assets/icons/instagram.png");
const TWITTER = require("../assets/icons/twitter.png");

export default {
    FACEBOOK,
    INSTAGRAM,
    TWITTER
}